import { getAiProviderOptions, type AiModelOption } from "../ai/models";
import {
  getAiModelIds,
  getAiModelOption,
  getAiModelOptions,
  getDefaultAiModelId,
  isAiModelIdForTask,
  type AiTaskModelId,
} from "../ai/tasks";

// TRE-2180 — the client-facing name of the advisor, in one place: headers, chat tabs,
// pushes and the agent's own persona all read it from here.
export const CLIENT_ADVISOR_NAME = "AI Opiekunka Metamorfozy";
/** Short form for running text: "Opiekunka pisze", "od Opiekunki", "z Opiekunką". */
export const CLIENT_ADVISOR_SHORT_NAME = "Opiekunka";

export const clientAdvisorModelOptionIds = getAiModelIds("advisor");
export type ClientAdvisorModelOptionId = AiTaskModelId<"advisor">;
export type ClientAdvisorModelProvider = AiModelOption["provider"];
export type ClientAdvisorModelOption = ReturnType<typeof getClientAdvisorModelOption>;
export const defaultClientAdvisorModelOptionId = getDefaultAiModelId("advisor");
export const clientAdvisorModelOptions = getAiModelOptions("advisor");
export const isClientAdvisorModelOptionId = (value?: string | null): value is ClientAdvisorModelOptionId =>
  isAiModelIdForTask("advisor", value);
export const getClientAdvisorModelOption = (id?: string | null) => getAiModelOption("advisor", id);
export const getClientAdvisorProviderOptions = getAiProviderOptions;

export interface ClientAdvisorConfigData {
  modelOptionId: ClientAdvisorModelOptionId;
}
